import { render } from "./TimelineEvent.vue?vue&type=template&id=5331a3e9"
import script from "./TimelineEvent.vue?vue&type=script&lang=js"
export * from "./TimelineEvent.vue?vue&type=script&lang=js"

import "./TimelineEvent.vue?vue&type=style&index=0&id=5331a3e9&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__